import { FullPost } from 'model';
import { useCallback, useState } from 'react';
import { ExpandableSummary } from './ExpandableSummary';
import { PostContentsToHTML } from './PostContentsToHTML';
import { useHistory } from 'react-router';

// This is meant to present a medium length summary of the post contents.
export const PostContentsSummary: React.FC<{
	post: FullPost;
	allowExpand?: boolean;
	expanded?: boolean;
}> = ({ post, allowExpand, expanded }) => {
	const history = useHistory();
	const [postExpanded, setExpanded] = useState(Boolean(expanded));

	const handleExpand = useCallback(() => {
		if (allowExpand === true) {
			setExpanded(true);
		} else {
			history.push(`/main/latest/post/show/${post._id}/expanded`);
		}
	}, [allowExpand, history, post._id]);

	return (
		<ExpandableSummary expanded={postExpanded} setExpanded={handleExpand}>
			<PostContentsToHTML>{post.contents}</PostContentsToHTML>
		</ExpandableSummary>
	);
};
